<template>
<ul>
  <li class="empty top-spacer"></li>
  <li v-for="item in menuEmpty" class="empty"></li>
  <li v-for="(menuItem, mi) in menuItems" :class="{open: menuSubOpen===mi, active: menuItem.active}">
    <a :href="resolvedLink(menuItem.link)" v-on:click="openSubMenu($event, mi)">{{ __t(menuItem.title) }}</a>
    <ul v-if="menuItem.sub && menuItem.sub.length" :class="{'filter-head': menuItem.isFilter}">
      <li v-for="(menuItem2, mi2) in menuItem.sub || []" :class="{dw: menuItem2.mode=='dw'}">
        <a :href="resolvedLink(menuItem2.link)" v-on:click="clickItem(menuItem3)">{{ menuItem2.title }}</a>
        <ul v-if="menuItem2.mode=='dw'">
          <li>
            <div class="menu-subt">{{ __t(menuItem2.col1.title) }}</div>
            <ul>
              <li v-for="(menuItem3, mi3) in menuItem2.col1.sub">
                <a :href="resolvedLink(menuItem3.link)" v-on:click.prevent="clickItem(menuItem3)">{{ menuItem3.title }}</a>
              </li>
            </ul>
          </li>
          <li>
            <div class="menu-subt">{{ __t(menuItem2.col2.title) }}</div>
            <ul>
              <li v-for="(menuItem3, mi3) in menuItem2.col2.sub">
                <a :href="resolvedLink(menuItem3.link)" v-on:click.prevent="clickItem(menuItem3)">{{ __t(menuItem3.title) }}</a>
              </li>
            </ul>
          </li>
        </ul>
        <ul v-else>
          <li v-for="(menuItem3, mi3) in menuItem2.sub">
            <a :href="resolvedLink(menuItem3.link)" v-on:click.prevent="clickItem(menuItem3)">{{ __t(menuItem3.title) }}</a>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</ul>
</template>
<script>
export default {
  props: ["menuItems"],
  data: ()=>({
    menuSubOpen: null,
  }),
  computed: {
    menuEmpty() {
      var result=[];
      for(var i=0;i<7-this.menuItems.length;i++) {
        result.push({});
      }
      return result;
    },
  },
  methods: {
    openSubMenu($event, index) {
      $event.preventDefault();
      if (this.menuSubOpen===index || !this.menuItems[index].sub) {
        this.clickItem(this.menuItems[index])
      } else {
        this.menuSubOpen=index;
      }
    },
    clickItemHandler($event, item) {
      $event.preventDefault();
      clickItem(item);
    },
    clickItem(item) {
      if (item.action) {
        this.$emit('action', {name: item.action, args: item.args});
      } else if (item.link) {
        if (typeof(item.link)=="string" && item.link.indexOf("http")==0)
          window.open(item.link, "_self");
        else
          this.$router.push(item.link);
      }
    },
    resolvedLink(link) {
      if (typeof(link)=="string")
        return link;
      return this.$router.resolve(link).href;
    },
  },
}
</script>
